import React from 'react';
import { ActivityCard, Empty } from '../../../components/ui';

interface Props {
    data: any[] | [],
    loading: boolean
}

export default function ActivitySection({ data, loading }: Props) {
    const hasItems = (data || []).some((item) =>
        (item?.programs || []).some((f: any) => !f.isCompleted && f.isPaid)
    );

    return (
        <div className="relative w-full min-w-0">
            {loading ? (
                <div className="flex h-40 items-center justify-center">
                    <div className="h-16 w-16 animate-spin rounded-full border border-ryd-primary border-l-white" />
                </div>
            ) : !hasItems ? (
                <div className="rounded-[18px] border border-dashed border-[#e8dce8] bg-[#FBF8FC] px-6 py-16 text-center">
                    <Empty text={<>You have no activity yet.<br />Click &apos;Add New Child&apos; to get started.</>} />
                </div>
            ) : (
                <div className="grid gap-5">
                    {data?.map((item) =>
                        item?.programs
                            ?.filter((f: any) => !f.isCompleted && f.isPaid)
                            .map((activity: any) => (
                                <ActivityCard
                                    key={`${item.id}-${activity.id}`}
                                    childName={item?.firstName}
                                    imageUrl={activity?.package?.imageUrl}
                                    title={activity?.package?.title}
                                    level={activity?.package?.level}
                                    amount={activity?.package?.amount}
                                    altAmount={activity?.package?.altAmount}
                                    description={activity?.package?.description}
                                    minAge={activity?.package?.minAge}
                                    maxAge={activity?.package?.maxAge}
                                    week={activity?.package?.weekDuration}
                                    createdAt={activity?.package?.createdAt}
                                    mediaUrl={activity?.mediaUrl}
                                    teacher={activity?.teacher?.firstName + ' ' + activity?.teacher?.lastName}
                                    attendance={activity.attendance}
                                    classUrl={activity?.teacher?.classLink}
                                    oldClassLink={activity?.teacher?.classLink}
                                    docUrl={activity?.teacher?.docUrl}
                                    isActive={!activity?.isCompleted}
                                    cohort={activity?.cohort}
                                />
                            ))
                    )}
                </div>
            )}
        </div>
    );
}
